import { I18n } from 'react-redux-i18n';
import { take, put, call, all, select } from 'redux-saga/effects';
import { notify } from '../../../../../Components/Notifier/services/saga';
import { displayInfoPartner } from '../../partners/saga';

import {
	generateExternalId,
	initApiData,
	preGenerateLinkPartnerToCustomer,
	setPartnerMedDefaut,
} from '../saga';
import { PRE_CHANGE_PARTNER_STATUS, PRE_CHANGE_PARTNER_STEP } from '../types';

const PARTNER_PREFIX = 'belorder';

function* config() {
	while (true) {
		const { data } = yield take('PUT_CONFIG_BELORDER');

		let success = false;
		let errorMessage = null;
		let currentStep = data.step;

		let bodySetStep = {
			id_user: data.userId,
			partner_id: data.partnerId,
			step: data.nextStep,
			status: data.status,
		};

		const { partners } = yield select();
		let external_id =
			partners && partners[PARTNER_PREFIX]
				? partners[PARTNER_PREFIX].external_id
				: null;

		if (currentStep === 'initial') {
			yield call(setPartnerMedDefaut, {
				partnerPrefix: data.prefix,
				partnerId: data.partnerId,
			});

			currentStep = 'set_api_data';
			bodySetStep.step = 'set_api_data';
			success = true;
		}

		if (currentStep === 'set_api_data') {
			const successInitApiData = yield call(initApiData, PARTNER_PREFIX);
			if (successInitApiData) {
				success = true;
				currentStep = 'set_customer_id';
				bodySetStep.step = 'set_customer_id';
			}
		}
		if (currentStep === 'set_customer_id') {
			let res = yield call(generateExternalId);
			if (res && res.success) {
				external_id = res.result;

				yield put({
					type: 'PRE_PATCH_PARTNER_EXTERNAL_ID',
					body: { prefix: PARTNER_PREFIX, external_id },
				});

				success = true;
				currentStep = 'set_auth_link';
				bodySetStep.step = 'set_auth_link';
			}
		}

		if (currentStep === 'set_auth_link') {
			if (external_id) {
				let res = yield call(preGenerateLinkPartnerToCustomer, {
					partnerId: data.partnerId,
					uuid: external_id,
				});

				if (res && res.success) {
					currentStep = 'success';
					bodySetStep.step = 'success';
					bodySetStep.status = 'actif';
				}
			} else {
				errorMessage = 'partner.onboarding_como_errors.' + currentStep;
			}
		}

		if (success) {
			yield put({
				type: PRE_CHANGE_PARTNER_STEP,
				body: bodySetStep,
			});
			if (bodySetStep.step === 'success') {
				yield put({
					type: PRE_CHANGE_PARTNER_STATUS,
					body: bodySetStep,
				});
				yield call(displayInfoPartner, PARTNER_PREFIX);
			}
		}

		if (errorMessage) {
			yield call(notify, I18n.t(errorMessage), 'error');
		}

		yield put({ type: 'PUT_CONFIG_BELORDER_FINISHED', step: bodySetStep.step });
	}
}

export default function* indexSaga() {
	yield all([config()]);
}
